var exports = {
  "CR": "MessageReactionsModal.module__modalRoot___a0NtQ0" + " " + __webpack_require__(900792)["root"] + " " + __webpack_require__(900792)["default"],
  "jE": "MessageReactionsModal.module__modalContent___a0NtQ0",
  "Ij": "MessageReactionsModal.module__modalLayout___a0NtQ0",
  "pz": "MessageReactionsModal.module__sidebar___a0NtQ0",
  "PC": "MessageReactionsModal.module__reactionFiltersPane___a0NtQ0",
  "VG": "MessageReactionsModal.module__reactionListContainer___a0NtQ0",
};

module.exports = exports;
